import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { LanguageGate } from "./LanguageGate";

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-cream">
      <LanguageGate />
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
